export default "__VITE_ASSET__BZkH4tl9__"